import { FC, useState } from 'react';
import classes from './RequestError.module.scss';
import { Button } from '@mui/material';
import clsx from 'clsx';
import { MIME_TYPES } from '../../config/veriables';


const validate = (input: File[]) => {
  const isTypeError = input.some((item) => !MIME_TYPES.includes(item.type.toLowerCase()));
  if (isTypeError) {
    return false;
  }

  const isSizeError = input.some((item) => item.size > 10*1024*1024);
  if (isSizeError) {
    return false;
  }

  return true;
}

export const RequestError: FC<{ onBack?: () => void; fileNames: string[]; onFileDrop: (input: File[]) => void}> = ({
  onFileDrop, onBack, fileNames,
}) => {
  const [drag, setDrag] = useState(false);
  const [enterTimestamp, setEnterTimestamp] = useState(0);

  const hideInput = () => {
    if ((Date.now() - enterTimestamp) > 50) {
      setDrag(false);
      setEnterTimestamp(0);
    }
  };

  return (
    <div
      className={clsx(classes.wrapper, { [classes.drag]: drag })}
      onDragEnter={() => {
        setDrag(true);
        setEnterTimestamp(Date.now());
      }}
      onDragLeave={hideInput}
      onDragEnd={hideInput}
      onDragExit={hideInput}
      onDrop={hideInput}
    >
      <div className={classes.container}>
        <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M38.5 29.0002V41.6669M14.3666 48.633C11.4867 53.6208 10.0472 56.1158 10.2622 58.1624C10.4499 59.9475 11.3868 61.5694 12.8389 62.6243C14.5031 63.8336 17.3812 63.8336 23.137 63.8336H53.8631C59.6188 63.8336 62.4964 63.8336 64.1608 62.6243C65.6127 61.5694 66.55 59.9475 66.7378 58.1624C66.9528 56.1158 65.5139 53.6208 62.6338 48.633L47.2764 22.0329C44.3967 17.0448 42.9558 14.5512 41.0761 13.7142C39.4364 12.9841 37.5627 12.9841 35.923 13.7142C34.0439 14.5508 32.604 17.0445 29.7266 22.0284L14.3666 48.633ZM38.6609 51.1669V51.4836L38.3423 51.4842V51.1669H38.6609Z" stroke="#E01742" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

        <div className={classes.textContainer}>
          <div className={classes.red}>Error processing: {fileNames.join(', ')}</div>
          <div>Your session timed out. please refresh the page and try again.</div>
          <div className={classes.bold}>Try again or drag & drop another document</div>
        </div>

        <Button variant="contained" onClick={onBack}>Try Again</Button>
      </div>

      <input
        className={clsx(classes.fileInput, { [classes.show]: drag })}
        type="file"
        multiple
        onChange={({ target: { files } }) => {
          if (!files) {
            return;
          }

          const output: File[] = [];
          for (let i = 0; i < files.length; i++) {
            output.push(files.item(i) as File);
          }

          if (validate(output)) {
            onFileDrop(output);
          }
        }}
      />
    </div>
  );
}
